import React, { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { DataAuditoriaDropDown } from '../domain/models/data_auditoria_dropdown';
import { DataCronogramaSGQDropDown } from '../domain/models/data_cronogramaSGQ__dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
  Tipo: "DataRealizada" | "DataPrevista";
};

export const DefaultDataCronogramaSGQ = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
  Tipo,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [dataCronogramaSGQDropDown, setDataCronogramaSGQDropDown] = useState<DataCronogramaSGQDropDown[]>([]);

  const {
    commons: {
      getDataCronogramaSGQDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getDataCronogramaSGQDropDownUseCase.getDataCronogramaSGQDropDown(Tipo);
      setDataCronogramaSGQDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar datas CronogramaSGQ!'));
    }
  }, [Tipo, getDataCronogramaSGQDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={dataCronogramaSGQDropDown}
        getOptionLabel={(opt) => String(opt.data)}
        isOptionEqualToValue={(opt, val) => String(opt.data) === String(val.data)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={dataCronogramaSGQDropDown.find(x => String(x.data) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.data : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};